import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { INNER_ROUTES } from "../constants/inner-routes";

// We define this outside the hook so it persists during internal 
// navigations, but gets wiped on a full page refresh.
let isFirstLoad = true;
let currentPath = '';

export const useGoBack = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [canGoBack, setCanGoBack] = useState(!isFirstLoad);

  useEffect(() => {
    // If it's the first time this code runs after a refresh
    if (isFirstLoad) {
      isFirstLoad = false;
      currentPath = location.pathname;
      setCanGoBack(false);
    } else if (currentPath !== location.pathname) {
      // After the first internal navigation, we can go back safely
      setCanGoBack(true);
    }
  }, [location]);

  return () => {
    if (canGoBack) {
      navigate(-1);
    } else {
      navigate(INNER_ROUTES.HOME, { replace: true });
    }
  };
};


// export const useGoBack = () => {
//   const navigate = useNavigate();

//   const isPreviousRoute = window.history.length > 1;

//   return () => isPreviousRoute ? navigate(-1) : navigate(INNER_ROUTES.HOME, { replace: true });
// };